<template>
  <!-- Add -->
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- Input Fields -->
            <div class="mb-3">
              <label class="col-form-label"
                >Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="name" />
              <div class="text-danger" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>
            <div
              v-for="(address, index) in addresses"
              :key="index"
              class="address-group mb-3"
            >
              <div class="address-label d-flex justify-content-end">
                <label class="col-form-label">Address {{ index + 1 }}:</label>
              </div>
              <div class="mb-2">
                <label class="col-form-label"
                  >Phone <span class="text-danger">*</span></label
                >
                <input
                  type="tel"
                  placeholder="Enter Phone"
                  v-model="address.phone"
                  class="form-control mb-2"
                  required
                />
                <label class="col-form-label"
                  >Country <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  placeholder="Enter Country"
                  v-model="address.country"
                  class="form-control mb-2"
                  required
                />
                <label class="col-form-label"
                  >State <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  placeholder="Enter State"
                  v-model="address.state"
                  class="form-control mb-2"
                  required
                />
                <label class="col-form-label"
                  >City <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  placeholder="Enter City"
                  v-model="address.city"
                  class="form-control mb-2"
                  required
                />
                <label class="col-form-label"
                  >Area <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  placeholder="Enter Area"
                  v-model="address.area"
                  class="form-control mb-2"
                  required
                />
                <button
                  class="btn btn-danger btn-sm"
                  type="button"
                  @click="removeAddress(index)"
                >
                  Remove
                </button>
              </div>
            </div>
            <button
              class="btn btn-primary btn-sm mb-3"
              type="button"
              @click="addAddress"
            >
              Add Another Address
            </button>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                {{ isEditMode ? "Update" : "Create" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add  -->

  <!-- Delete -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete -->
</template>
<script>
import http from "@/utils/http";

export default {
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    name: "",
    addresses: [{ phone: "", country: "", state: "", city: "", area: "" }],
    itemId: null,
    errors: {},
  }),

  mounted() {
    this.$emitter.on("add-edit-item", (row) => {
      if (row) {
        console.log(row);
        this.itemId = row.id;
        this.name = row.name;
        this.addresses =
          row?.address?.length > 0
            ? row?.address
            : [{ phone: "", country: "", state: "", city: "", area: "" }];
      }
      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });
  },

  methods: {
    async submitForm() {
      this.isLoading = true;
      const endpoint = this.isEditMode
        ? `/companies/${this.itemId}`
        : "/companies";
      const method = this.isEditMode ? "put" : "post";
      let body = {
        name: this.name,
        address: this.addresses,
      };
      try {
        const response = await http[method](endpoint, body);

        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/companies/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    addAddress() {
      this.addresses.push({
        phone: "",
        country: "",
        state: "",
        city: "",
        area: "",
      });
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
    },
  },
};
</script>
